
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"ci-primary",attrs:{"fill":"#0fb0e1","d":"M380 16H132a32.036 32.036 0 00-32 32v416a32.036 32.036 0 0032 32h248a32.036 32.036 0 0032-32V48a32.036 32.036 0 00-32-32zm0 32v32H132V48zm0 64l.011 224H132V112zm0 352H132v-96h248.016v96z"}}),_c('path',{staticClass:"ci-primary",attrs:{"fill":"#0fb0e1","d":"M240 400h32v32h-32z"}})])
          )
        }
      }
    